
import * as React from 'react'

const SvgComponent = ({
    ...props
}: React.SVGProps<SVGSVGElement>) => {
    const w = 30
    const h = 30
    return (
        <svg width={w} height={h} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"  {...props}>
            <path d="M18.3749 7.87565C18.1459 8.10931 18.0176 8.42346 18.0176 8.75065C18.0176 9.07784 18.1459 9.39199 18.3749 9.62565L20.3749 11.6256C20.6086 11.8547 20.9227 11.983 21.2499 11.983C21.5771 11.983 21.8913 11.8547 22.1249 11.6256L26.8374 6.91315C27.466 8.30213 27.6563 9.84969 27.383 11.3496C27.1097 12.8495 26.3858 14.2305 25.3078 15.3085C24.2297 16.3865 22.8488 17.1104 21.3489 17.3837C19.849 17.657 18.3014 17.4667 16.9124 16.8381L8.27494 25.4756C7.77766 25.9729 7.1032 26.2523 6.39994 26.2523C5.69668 26.2523 5.02222 25.9729 4.52494 25.4756C4.02766 24.9784 3.74829 24.3039 3.74829 23.6006C3.74829 22.8974 4.02766 22.2229 4.52494 21.7256L13.1624 13.0881C12.5339 11.6992 12.3436 10.1516 12.6169 8.65172C12.8902 7.15183 13.614 5.77084 14.6921 4.6928C15.7701 3.61476 17.1511 2.89086 18.651 2.61757C20.1509 2.34429 21.6985 2.5346 23.0874 3.16315L18.3874 7.86315L18.3749 7.87565Z" stroke="#020202" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default SvgComponent
